import { render, staticRenderFns } from "./GroupChatIcon.vue?vue&type=template&id=4aeb7bfa"
import script from "./GroupChatIcon.vue?vue&type=script&lang=js"
export * from "./GroupChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports